import React from 'react';
import ExpiredView from './ExpiredView';

const Expired: React.FC = props => {
  return <ExpiredView {...props} />;
};

export default Expired;
